import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['container', 'template', 'item', 'destroyField']

  connect () {
    this.index = this.containerTarget.children.length
  }

  addProduct () {
    const template = this.templateTarget.innerHTML
    const newProduct = template.replace(/TEMPLATE_RECORD/g, this.index++)
    this.containerTarget.insertAdjacentHTML('beforeend', newProduct)
  }

  removeProduct (event) {
    const item = event.target.closest("[data-nested-products-target='item']")
    const destroyField = item.querySelector("[data-nested-products-target='destroyField']")

    if (destroyField) {
      destroyField.value = '1'
      item.style.display = 'none'
    } else {
      item.remove()
    }
  }
}
